/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const librario = $root.librario = (() => {

    /**
     * Namespace librario.
     * @exports librario
     * @namespace
     */
    const librario = {};

    librario.config = (function() {

        /**
         * Namespace config.
         * @memberof librario
         * @namespace
         */
        const config = {};

        /**
         * SortOrder enum.
         * @name librario.config.SortOrder
         * @enum {number}
         * @property {number} SORT_LAST_WATCHED=0 SORT_LAST_WATCHED value
         * @property {number} SORT_NAME=1 SORT_NAME value
         * @property {number} SORT_RECENTLY_ADDED=2 SORT_RECENTLY_ADDED value
         * @property {number} SORT_LAST_MODIFIED=3 SORT_LAST_MODIFIED value
         * @property {number} SORT_NAME_DESC=4 SORT_NAME_DESC value
         * @property {number} SORT_YEAR=5 SORT_YEAR value
         * @property {number} SORT_YEAR_ASC=6 SORT_YEAR_ASC value
         * @property {number} SORT_RATING=7 SORT_RATING value
         * @property {number} SORT_TIMES_WATCHED=8 SORT_TIMES_WATCHED value
         * @property {number} SORT_OLDEST_ADDED=9 SORT_OLDEST_ADDED value
         * @property {number} SORT_WATCHED=10 SORT_WATCHED value
         * @property {number} SORT_NOT_WATCHED=11 SORT_NOT_WATCHED value
         */
        config.SortOrder = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SORT_LAST_WATCHED"] = 0;
            values[valuesById[1] = "SORT_NAME"] = 1;
            values[valuesById[2] = "SORT_RECENTLY_ADDED"] = 2;
            values[valuesById[3] = "SORT_LAST_MODIFIED"] = 3;
            values[valuesById[4] = "SORT_NAME_DESC"] = 4;
            values[valuesById[5] = "SORT_YEAR"] = 5;
            values[valuesById[6] = "SORT_YEAR_ASC"] = 6;
            values[valuesById[7] = "SORT_RATING"] = 7;
            values[valuesById[8] = "SORT_TIMES_WATCHED"] = 8;
            values[valuesById[9] = "SORT_OLDEST_ADDED"] = 9;
            values[valuesById[10] = "SORT_WATCHED"] = 10;
            values[valuesById[11] = "SORT_NOT_WATCHED"] = 11;
            return values;
        })();

        /**
         * MetadataProvider enum.
         * @name librario.config.MetadataProvider
         * @enum {number}
         * @property {number} PROVIDER_CINEMETA=0 PROVIDER_CINEMETA value
         * @property {number} PROVIDER_TMDB=1 PROVIDER_TMDB value
         * @property {number} PROVIDER_AUTO=2 PROVIDER_AUTO value
         */
        config.MetadataProvider = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PROVIDER_CINEMETA"] = 0;
            values[valuesById[1] = "PROVIDER_TMDB"] = 1;
            values[valuesById[2] = "PROVIDER_AUTO"] = 2;
            return values;
        })();

        /**
         * CatalogId enum.
         * @name librario.config.CatalogId
         * @enum {number}
         * @property {number} CONTINUE_WATCHING=0 CONTINUE_WATCHING value
         * @property {number} LIBRARY_MIXED=1 LIBRARY_MIXED value
         * @property {number} LIBRARY_MOVIE=2 LIBRARY_MOVIE value
         * @property {number} LIBRARY_SERIES=3 LIBRARY_SERIES value
         * @property {number} LIBRARY_CHANNEL=4 LIBRARY_CHANNEL value
         * @property {number} LIBRARY_TV=5 LIBRARY_TV value
         */
        config.CatalogId = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "CONTINUE_WATCHING"] = 0;
            values[valuesById[1] = "LIBRARY_MIXED"] = 1;
            values[valuesById[2] = "LIBRARY_MOVIE"] = 2;
            values[valuesById[3] = "LIBRARY_SERIES"] = 3;
            values[valuesById[4] = "LIBRARY_CHANNEL"] = 4;
            values[valuesById[5] = "LIBRARY_TV"] = 5;
            return values;
        })();

        config.Config = (function() {

            /**
             * Properties of a Config.
             * @memberof librario.config
             * @interface IConfig
             * @property {string|null} [auth_key] Config auth_key
             * @property {boolean|null} [group_by_type] Config group_by_type
             * @property {Array.<librario.config.ICatalogConfig>|null} [catalogs] Config catalogs
             * @property {string|null} [rpdb_api_key] Config rpdb_api_key
             * @property {number|null} [cache_validity_seconds] Config cache_validity_seconds
             * @property {string|null} [addon_name] Config addon_name
             * @property {string|null} [addon_description] Config addon_description
             * @property {boolean|null} [enable_metadata_fetching] Config enable_metadata_fetching
             * @property {librario.config.MetadataProvider|null} [metadata_provider] Config metadata_provider
             * @property {string|null} [tmdb_api_key] Config tmdb_api_key
             * @property {Object.<string,string>|null} [metadata] Config metadata
             */

            /**
             * Constructs a new Config.
             * @memberof librario.config
             * @classdesc Represents a Config.
             * @implements IConfig
             * @constructor
             * @param {librario.config.IConfig=} [properties] Properties to set
             */
            function Config(properties) {
                this.catalogs = [];
                this.metadata = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Config auth_key.
             * @member {string} auth_key
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.auth_key = "";

            /**
             * Config group_by_type.
             * @member {boolean} group_by_type
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.group_by_type = false;

            /**
             * Config catalogs.
             * @member {Array.<librario.config.ICatalogConfig>} catalogs
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.catalogs = $util.emptyArray;

            /**
             * Config rpdb_api_key.
             * @member {string|null|undefined} rpdb_api_key
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.rpdb_api_key = null;

            /**
             * Config cache_validity_seconds.
             * @member {number} cache_validity_seconds
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.cache_validity_seconds = 0;

            /**
             * Config addon_name.
             * @member {string|null|undefined} addon_name
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.addon_name = null;

            /**
             * Config addon_description.
             * @member {string|null|undefined} addon_description
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.addon_description = null;

            /**
             * Config enable_metadata_fetching.
             * @member {boolean} enable_metadata_fetching
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.enable_metadata_fetching = false;

            /**
             * Config metadata_provider.
             * @member {librario.config.MetadataProvider} metadata_provider
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.metadata_provider = 0;

            /**
             * Config tmdb_api_key.
             * @member {string|null|undefined} tmdb_api_key
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.tmdb_api_key = null;

            /**
             * Config metadata.
             * @member {Object.<string,string>} metadata
             * @memberof librario.config.Config
             * @instance
             */
            Config.prototype.metadata = $util.emptyObject;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Config _rpdb_api_key.
             * @member {"rpdb_api_key"|undefined} _rpdb_api_key
             * @memberof librario.config.Config
             * @instance
             */
            Object.defineProperty(Config.prototype, "_rpdb_api_key", {
                get: $util.oneOfGetter($oneOfFields = ["rpdb_api_key"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Config _addon_name.
             * @member {"addon_name"|undefined} _addon_name
             * @memberof librario.config.Config
             * @instance
             */
            Object.defineProperty(Config.prototype, "_addon_name", {
                get: $util.oneOfGetter($oneOfFields = ["addon_name"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Config _addon_description.
             * @member {"addon_description"|undefined} _addon_description
             * @memberof librario.config.Config
             * @instance
             */
            Object.defineProperty(Config.prototype, "_addon_description", {
                get: $util.oneOfGetter($oneOfFields = ["addon_description"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Config _tmdb_api_key.
             * @member {"tmdb_api_key"|undefined} _tmdb_api_key
             * @memberof librario.config.Config
             * @instance
             */
            Object.defineProperty(Config.prototype, "_tmdb_api_key", {
                get: $util.oneOfGetter($oneOfFields = ["tmdb_api_key"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Config instance using the specified properties.
             * @function create
             * @memberof librario.config.Config
             * @static
             * @param {librario.config.IConfig=} [properties] Properties to set
             * @returns {librario.config.Config} Config instance
             */
            Config.create = function create(properties) {
                return new Config(properties);
            };

            /**
             * Encodes the specified Config message. Does not implicitly {@link librario.config.Config.verify|verify} messages.
             * @function encode
             * @memberof librario.config.Config
             * @static
             * @param {librario.config.IConfig} message Config message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Config.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.auth_key != null && Object.hasOwnProperty.call(message, "auth_key"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.auth_key);
                if (message.group_by_type != null && Object.hasOwnProperty.call(message, "group_by_type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.group_by_type);
                if (message.catalogs != null && message.catalogs.length)
                    for (let i = 0; i < message.catalogs.length; ++i)
                        $root.librario.config.CatalogConfig.encode(message.catalogs[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.rpdb_api_key != null && Object.hasOwnProperty.call(message, "rpdb_api_key"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.rpdb_api_key);
                if (message.cache_validity_seconds != null && Object.hasOwnProperty.call(message, "cache_validity_seconds"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cache_validity_seconds);
                if (message.addon_name != null && Object.hasOwnProperty.call(message, "addon_name"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.addon_name);
                if (message.addon_description != null && Object.hasOwnProperty.call(message, "addon_description"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.addon_description);
                if (message.enable_metadata_fetching != null && Object.hasOwnProperty.call(message, "enable_metadata_fetching"))
                    writer.uint32(/* id 8, wireType 0 =*/64).bool(message.enable_metadata_fetching);
                if (message.metadata_provider != null && Object.hasOwnProperty.call(message, "metadata_provider"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.metadata_provider);
                if (message.tmdb_api_key != null && Object.hasOwnProperty.call(message, "tmdb_api_key"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.tmdb_api_key);
                if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                    for (let keys = Object.keys(message.metadata), i = 0; i < keys.length; ++i)
                        writer.uint32(/* id 99, wireType 2 =*/794).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.metadata[keys[i]]).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Config message, length delimited. Does not implicitly {@link librario.config.Config.verify|verify} messages.
             * @function encodeDelimited
             * @memberof librario.config.Config
             * @static
             * @param {librario.config.IConfig} message Config message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Config.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Config message from the specified reader or buffer.
             * @function decode
             * @memberof librario.config.Config
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {librario.config.Config} Config
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Config.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.librario.config.Config(), key, value;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.auth_key = reader.string();
                            break;
                        }
                    case 2: {
                            message.group_by_type = reader.bool();
                            break;
                        }
                    case 3: {
                            if (!(message.catalogs && message.catalogs.length))
                                message.catalogs = [];
                            message.catalogs.push($root.librario.config.CatalogConfig.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            message.rpdb_api_key = reader.string();
                            break;
                        }
                    case 5: {
                            message.cache_validity_seconds = reader.int32();
                            break;
                        }
                    case 6: {
                            message.addon_name = reader.string();
                            break;
                        }
                    case 7: {
                            message.addon_description = reader.string();
                            break;
                        }
                    case 8: {
                            message.enable_metadata_fetching = reader.bool();
                            break;
                        }
                    case 9: {
                            message.metadata_provider = reader.int32();
                            break;
                        }
                    case 10: {
                            message.tmdb_api_key = reader.string();
                            break;
                        }
                    case 99: {
                            if (message.metadata === $util.emptyObject)
                                message.metadata = {};
                            let end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = "";
                            while (reader.pos < end2) {
                                let tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.metadata[key] = value;
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Config message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof librario.config.Config
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {librario.config.Config} Config
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Config.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Config message.
             * @function verify
             * @memberof librario.config.Config
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Config.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.auth_key != null && message.hasOwnProperty("auth_key"))
                    if (!$util.isString(message.auth_key))
                        return "auth_key: string expected";
                if (message.group_by_type != null && message.hasOwnProperty("group_by_type"))
                    if (typeof message.group_by_type !== "boolean")
                        return "group_by_type: boolean expected";
                if (message.catalogs != null && message.hasOwnProperty("catalogs")) {
                    if (!Array.isArray(message.catalogs))
                        return "catalogs: array expected";
                    for (let i = 0; i < message.catalogs.length; ++i) {
                        let error = $root.librario.config.CatalogConfig.verify(message.catalogs[i]);
                        if (error)
                            return "catalogs." + error;
                    }
                }
                if (message.rpdb_api_key != null && message.hasOwnProperty("rpdb_api_key")) {
                    properties._rpdb_api_key = 1;
                    if (!$util.isString(message.rpdb_api_key))
                        return "rpdb_api_key: string expected";
                }
                if (message.cache_validity_seconds != null && message.hasOwnProperty("cache_validity_seconds"))
                    if (!$util.isInteger(message.cache_validity_seconds))
                        return "cache_validity_seconds: integer expected";
                if (message.addon_name != null && message.hasOwnProperty("addon_name")) {
                    properties._addon_name = 1;
                    if (!$util.isString(message.addon_name))
                        return "addon_name: string expected";
                }
                if (message.addon_description != null && message.hasOwnProperty("addon_description")) {
                    properties._addon_description = 1;
                    if (!$util.isString(message.addon_description))
                        return "addon_description: string expected";
                }
                if (message.enable_metadata_fetching != null && message.hasOwnProperty("enable_metadata_fetching"))
                    if (typeof message.enable_metadata_fetching !== "boolean")
                        return "enable_metadata_fetching: boolean expected";
                if (message.metadata_provider != null && message.hasOwnProperty("metadata_provider"))
                    switch (message.metadata_provider) {
                    default:
                        return "metadata_provider: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.tmdb_api_key != null && message.hasOwnProperty("tmdb_api_key")) {
                    properties._tmdb_api_key = 1;
                    if (!$util.isString(message.tmdb_api_key))
                        return "tmdb_api_key: string expected";
                }
                if (message.metadata != null && message.hasOwnProperty("metadata")) {
                    if (!$util.isObject(message.metadata))
                        return "metadata: object expected";
                    let key = Object.keys(message.metadata);
                    for (let i = 0; i < key.length; ++i)
                        if (!$util.isString(message.metadata[key[i]]))
                            return "metadata: string{k:string} expected";
                }
                return null;
            };

            /**
             * Creates a Config message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof librario.config.Config
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {librario.config.Config} Config
             */
            Config.fromObject = function fromObject(object) {
                if (object instanceof $root.librario.config.Config)
                    return object;
                let message = new $root.librario.config.Config();
                if (object.auth_key != null)
                    message.auth_key = String(object.auth_key);
                if (object.group_by_type != null)
                    message.group_by_type = Boolean(object.group_by_type);
                if (object.catalogs) {
                    if (!Array.isArray(object.catalogs))
                        throw TypeError(".librario.config.Config.catalogs: array expected");
                    message.catalogs = [];
                    for (let i = 0; i < object.catalogs.length; ++i) {
                        if (typeof object.catalogs[i] !== "object")
                            throw TypeError(".librario.config.Config.catalogs: object expected");
                        message.catalogs[i] = $root.librario.config.CatalogConfig.fromObject(object.catalogs[i]);
                    }
                }
                if (object.rpdb_api_key != null)
                    message.rpdb_api_key = String(object.rpdb_api_key);
                if (object.cache_validity_seconds != null)
                    message.cache_validity_seconds = object.cache_validity_seconds | 0;
                if (object.addon_name != null)
                    message.addon_name = String(object.addon_name);
                if (object.addon_description != null)
                    message.addon_description = String(object.addon_description);
                if (object.enable_metadata_fetching != null)
                    message.enable_metadata_fetching = Boolean(object.enable_metadata_fetching);
                switch (object.metadata_provider) {
                default:
                    if (typeof object.metadata_provider === "number") {
                        message.metadata_provider = object.metadata_provider;
                        break;
                    }
                    break;
                case "PROVIDER_CINEMETA":
                case 0:
                    message.metadata_provider = 0;
                    break;
                case "PROVIDER_TMDB":
                case 1:
                    message.metadata_provider = 1;
                    break;
                case "PROVIDER_AUTO":
                case 2:
                    message.metadata_provider = 2;
                    break;
                }
                if (object.tmdb_api_key != null)
                    message.tmdb_api_key = String(object.tmdb_api_key);
                if (object.metadata) {
                    if (typeof object.metadata !== "object")
                        throw TypeError(".librario.config.Config.metadata: object expected");
                    message.metadata = {};
                    for (let keys = Object.keys(object.metadata), i = 0; i < keys.length; ++i)
                        message.metadata[keys[i]] = String(object.metadata[keys[i]]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Config message. Also converts values to other types if specified.
             * @function toObject
             * @memberof librario.config.Config
             * @static
             * @param {librario.config.Config} message Config
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Config.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.catalogs = [];
                if (options.objects || options.defaults)
                    object.metadata = {};
                if (options.defaults) {
                    object.auth_key = "";
                    object.group_by_type = false;
                    object.cache_validity_seconds = 0;
                    object.enable_metadata_fetching = false;
                    object.metadata_provider = options.enums === String ? "PROVIDER_CINEMETA" : 0;
                }
                if (message.auth_key != null && message.hasOwnProperty("auth_key"))
                    object.auth_key = message.auth_key;
                if (message.group_by_type != null && message.hasOwnProperty("group_by_type"))
                    object.group_by_type = message.group_by_type;
                if (message.catalogs && message.catalogs.length) {
                    object.catalogs = [];
                    for (let j = 0; j < message.catalogs.length; ++j)
                        object.catalogs[j] = $root.librario.config.CatalogConfig.toObject(message.catalogs[j], options);
                }
                if (message.rpdb_api_key != null && message.hasOwnProperty("rpdb_api_key")) {
                    object.rpdb_api_key = message.rpdb_api_key;
                    if (options.oneofs)
                        object._rpdb_api_key = "rpdb_api_key";
                }
                if (message.cache_validity_seconds != null && message.hasOwnProperty("cache_validity_seconds"))
                    object.cache_validity_seconds = message.cache_validity_seconds;
                if (message.addon_name != null && message.hasOwnProperty("addon_name")) {
                    object.addon_name = message.addon_name;
                    if (options.oneofs)
                        object._addon_name = "addon_name";
                }
                if (message.addon_description != null && message.hasOwnProperty("addon_description")) {
                    object.addon_description = message.addon_description;
                    if (options.oneofs)
                        object._addon_description = "addon_description";
                }
                if (message.enable_metadata_fetching != null && message.hasOwnProperty("enable_metadata_fetching"))
                    object.enable_metadata_fetching = message.enable_metadata_fetching;
                if (message.metadata_provider != null && message.hasOwnProperty("metadata_provider"))
                    object.metadata_provider = options.enums === String ? $root.librario.config.MetadataProvider[message.metadata_provider] === undefined ? message.metadata_provider : $root.librario.config.MetadataProvider[message.metadata_provider] : message.metadata_provider;
                if (message.tmdb_api_key != null && message.hasOwnProperty("tmdb_api_key")) {
                    object.tmdb_api_key = message.tmdb_api_key;
                    if (options.oneofs)
                        object._tmdb_api_key = "tmdb_api_key";
                }
                let keys2;
                if (message.metadata && (keys2 = Object.keys(message.metadata)).length) {
                    object.metadata = {};
                    for (let j = 0; j < keys2.length; ++j)
                        object.metadata[keys2[j]] = message.metadata[keys2[j]];
                }
                return object;
            };

            /**
             * Converts this Config to JSON.
             * @function toJSON
             * @memberof librario.config.Config
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Config.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Config
             * @function getTypeUrl
             * @memberof librario.config.Config
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Config.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/librario.config.Config";
            };

            return Config;
        })();

        config.CatalogConfig = (function() {

            /**
             * Properties of a CatalogConfig.
             * @memberof librario.config
             * @interface ICatalogConfig
             * @property {string|null} [id] CatalogConfig id
             * @property {string|null} [name] CatalogConfig name
             * @property {string|null} [type] CatalogConfig type
             * @property {string|null} [sort_order] CatalogConfig sort_order
             * @property {boolean|null} [enabled] CatalogConfig enabled
             * @property {number|null} [position] CatalogConfig position
             * @property {boolean|null} [show_removed_items] CatalogConfig show_removed_items
             * @property {boolean|null} [is_continue_watching] CatalogConfig is_continue_watching
             * @property {number|null} [items_per_page] CatalogConfig items_per_page
             */

            /**
             * Constructs a new CatalogConfig.
             * @memberof librario.config
             * @classdesc Represents a CatalogConfig.
             * @implements ICatalogConfig
             * @constructor
             * @param {librario.config.ICatalogConfig=} [properties] Properties to set
             */
            function CatalogConfig(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CatalogConfig id.
             * @member {string} id
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.id = "";

            /**
             * CatalogConfig name.
             * @member {string} name
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.name = "";

            /**
             * CatalogConfig type.
             * @member {string} type
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.type = "";

            /**
             * CatalogConfig sort_order.
             * @member {string} sort_order
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.sort_order = "";

            /**
             * CatalogConfig enabled.
             * @member {boolean} enabled
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.enabled = false;

            /**
             * CatalogConfig position.
             * @member {number} position
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.position = 0;

            /**
             * CatalogConfig show_removed_items.
             * @member {boolean} show_removed_items
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.show_removed_items = false;

            /**
             * CatalogConfig is_continue_watching.
             * @member {boolean} is_continue_watching
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.is_continue_watching = false;

            /**
             * CatalogConfig items_per_page.
             * @member {number} items_per_page
             * @memberof librario.config.CatalogConfig
             * @instance
             */
            CatalogConfig.prototype.items_per_page = 0;

            /**
             * Creates a new CatalogConfig instance using the specified properties.
             * @function create
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {librario.config.ICatalogConfig=} [properties] Properties to set
             * @returns {librario.config.CatalogConfig} CatalogConfig instance
             */
            CatalogConfig.create = function create(properties) {
                return new CatalogConfig(properties);
            };

            /**
             * Encodes the specified CatalogConfig message. Does not implicitly {@link librario.config.CatalogConfig.verify|verify} messages.
             * @function encode
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {librario.config.ICatalogConfig} message CatalogConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CatalogConfig.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                if (message.sort_order != null && Object.hasOwnProperty.call(message, "sort_order"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.sort_order);
                if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.enabled);
                if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.position);
                if (message.show_removed_items != null && Object.hasOwnProperty.call(message, "show_removed_items"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.show_removed_items);
                if (message.is_continue_watching != null && Object.hasOwnProperty.call(message, "is_continue_watching"))
                    writer.uint32(/* id 8, wireType 0 =*/64).bool(message.is_continue_watching);
                if (message.items_per_page != null && Object.hasOwnProperty.call(message, "items_per_page"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.items_per_page);
                return writer;
            };

            /**
             * Encodes the specified CatalogConfig message, length delimited. Does not implicitly {@link librario.config.CatalogConfig.verify|verify} messages.
             * @function encodeDelimited
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {librario.config.ICatalogConfig} message CatalogConfig message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CatalogConfig.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CatalogConfig message from the specified reader or buffer.
             * @function decode
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {librario.config.CatalogConfig} CatalogConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CatalogConfig.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.librario.config.CatalogConfig();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.id = reader.string();
                            break;
                        }
                    case 2: {
                            message.name = reader.string();
                            break;
                        }
                    case 3: {
                            message.type = reader.string();
                            break;
                        }
                    case 4: {
                            message.sort_order = reader.string();
                            break;
                        }
                    case 5: {
                            message.enabled = reader.bool();
                            break;
                        }
                    case 6: {
                            message.position = reader.int32();
                            break;
                        }
                    case 7: {
                            message.show_removed_items = reader.bool();
                            break;
                        }
                    case 8: {
                            message.is_continue_watching = reader.bool();
                            break;
                        }
                    case 9: {
                            message.items_per_page = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CatalogConfig message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {librario.config.CatalogConfig} CatalogConfig
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CatalogConfig.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CatalogConfig message.
             * @function verify
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CatalogConfig.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.sort_order != null && message.hasOwnProperty("sort_order"))
                    if (!$util.isString(message.sort_order))
                        return "sort_order: string expected";
                if (message.enabled != null && message.hasOwnProperty("enabled"))
                    if (typeof message.enabled !== "boolean")
                        return "enabled: boolean expected";
                if (message.position != null && message.hasOwnProperty("position"))
                    if (!$util.isInteger(message.position))
                        return "position: integer expected";
                if (message.show_removed_items != null && message.hasOwnProperty("show_removed_items"))
                    if (typeof message.show_removed_items !== "boolean")
                        return "show_removed_items: boolean expected";
                if (message.is_continue_watching != null && message.hasOwnProperty("is_continue_watching"))
                    if (typeof message.is_continue_watching !== "boolean")
                        return "is_continue_watching: boolean expected";
                if (message.items_per_page != null && message.hasOwnProperty("items_per_page"))
                    if (!$util.isInteger(message.items_per_page))
                        return "items_per_page: integer expected";
                return null;
            };

            /**
             * Creates a CatalogConfig message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {librario.config.CatalogConfig} CatalogConfig
             */
            CatalogConfig.fromObject = function fromObject(object) {
                if (object instanceof $root.librario.config.CatalogConfig)
                    return object;
                let message = new $root.librario.config.CatalogConfig();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.sort_order != null)
                    message.sort_order = String(object.sort_order);
                if (object.enabled != null)
                    message.enabled = Boolean(object.enabled);
                if (object.position != null)
                    message.position = object.position | 0;
                if (object.show_removed_items != null)
                    message.show_removed_items = Boolean(object.show_removed_items);
                if (object.is_continue_watching != null)
                    message.is_continue_watching = Boolean(object.is_continue_watching);
                if (object.items_per_page != null)
                    message.items_per_page = object.items_per_page | 0;
                return message;
            };

            /**
             * Creates a plain object from a CatalogConfig message. Also converts values to other types if specified.
             * @function toObject
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {librario.config.CatalogConfig} message CatalogConfig
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CatalogConfig.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.id = "";
                    object.name = "";
                    object.type = "";
                    object.sort_order = "";
                    object.enabled = false;
                    object.position = 0;
                    object.show_removed_items = false;
                    object.is_continue_watching = false;
                    object.items_per_page = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.sort_order != null && message.hasOwnProperty("sort_order"))
                    object.sort_order = message.sort_order;
                if (message.enabled != null && message.hasOwnProperty("enabled"))
                    object.enabled = message.enabled;
                if (message.position != null && message.hasOwnProperty("position"))
                    object.position = message.position;
                if (message.show_removed_items != null && message.hasOwnProperty("show_removed_items"))
                    object.show_removed_items = message.show_removed_items;
                if (message.is_continue_watching != null && message.hasOwnProperty("is_continue_watching"))
                    object.is_continue_watching = message.is_continue_watching;
                if (message.items_per_page != null && message.hasOwnProperty("items_per_page"))
                    object.items_per_page = message.items_per_page;
                return object;
            };

            /**
             * Converts this CatalogConfig to JSON.
             * @function toJSON
             * @memberof librario.config.CatalogConfig
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CatalogConfig.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for CatalogConfig
             * @function getTypeUrl
             * @memberof librario.config.CatalogConfig
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            CatalogConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/librario.config.CatalogConfig";
            };

            return CatalogConfig;
        })();

        return config;
    })();

    return librario;
})();

export { $root as default };
